module.exports = __webpack_public_path__ + "static/media/openapp.efb094ff.jpeg";